module.exports = __webpack_public_path__ + "img/sellercentre.5caf601.png";